import React, { useEffect, useState } from 'react'
import { Flex } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useToasts } from 'react-toast-notifications'
import { useRecoilState } from 'recoil'
import { userState } from '../service/database'
import api from '../service/axios'

const FileViewer = (props) => {

    const { addToast } = useToasts()
    const { url, id } = props
    const [urlFile, setUrlFile] = useState(undefined)
    const [loading, setLoading] = useState(false)
    const [user,] = useRecoilState(userState)

    useEffect(() => {
        loadFile(url)
    }, [url])


    async function loadFile() {
        try {
   //console.log('URL: ',url)
            if (url) {
                setLoading(true)
                //  const result = await downloadFile(user?.token, { url: url })
             //   console.log(url)
                const result = await api.post('api/v1.0/registrado/downloadFile', { url: url },
                    {
                        headers: {
                            'x-access-token': user?.token2
                        },
                        params: {
                            id: id
                        },
                         responseType: 'blob'
                    }
                )


                const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                // Cria uma URL temporária para o Blob 
                const url2 = window.URL.createObjectURL(pdfBlob);
                setUrlFile(url2)
            }

        } catch (error) {
            console.log(error.message)
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }






    return <Flex style={{ width: '100%', backgroundColor: 'lightgray', minHeight: '60%' }}>
        {loading && <Flex vertical align='center' justify='center' gap={20} style={{ width: '100%' }}>
            <LoadingOutlined /> loading... </Flex>}
        {(url && loading === false) ?
            <iframe title='Arquivos' src={urlFile} style={{ width: '100%', minHeight: '100%', height: 700 }}></iframe>
            :
            <Flex flex={1} style={{ width: '100%' }}>. </Flex>
        }

    </Flex>
}

export default FileViewer